import { useMutation, useQueryClient } from '@tanstack/react-query';

import { markNotificationAsRead } from '../api/notifications.api';

/**
 * Hook for marking a single notification as read.
 * Optimistically updates the notification in cache.
 */
export const useMarkNotificationRead = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: markNotificationAsRead,
    onSuccess: () => {
      // Invalidate notifications queries to refetch with updated read status
      queryClient.invalidateQueries({ queryKey: ['notifications'] });
    },
  });
};
